import React from 'react';
import Modal from 'react-bootstrap/Modal';
import InputField from '../Reusable/InputField';
import { handleErrorMessage } from '../../utils';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';

class ModalForAddComplementRequestApproval extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      description: '',

      errors: {},
    };
  }

  componentDidMount() {
    if (this.props.signal)
      this.props.findLastComplementRequestApprovalByRequestId(
        this.props.requestForSignetApproval.id
      );
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleClientValidation = () => {
    let hasError = false;

    let errors = {};

    if (!this.state.description) {
      errors['description'] = this.props.t.Errors.description;
      hasError = true;
    }
    if (this.state.description && this.state.description.length > 2000) {
      errors['description'] = this.props.t.Errors.descriptionLength;
      hasError = true;
    }

    this.setState({ errors });
    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation()) {
      return;
    }

    const newComplementRequestApproval = {
      requestForSignetApproval: {
        ...this.props.requestForSignetApproval,
      },
      description: this.state.description,
      creator: this.props.loggedUser,
    };

    this.props.handleAdd(newComplementRequestApproval);
  };

  render() {
    const { error, t } = this.props || {},
      { Labels } = t || {};

    const previewStyle = this.props.signal
      ? 'col-md-12 mb-3 preview-style'
      : 'col-md-12 mb-3';
    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{Labels.title}</h5>
            <form noValidate onSubmit={this.handleSubmit}>
              <div className="row">
                <div className={previewStyle} disabled>
                  <InputField
                    name="description"
                    placeholder={
                      this.props
                        ? t.Placeholders.descriptionForPreview
                        : t.Placeholders.description
                    }
                    multiple={false}
                    required={!this.props.signal}
                    onChange={this.onChange}
                    value={
                      this.props.signal
                        ? this.props.complementRequestApproval?.description
                        : this.state.description
                    }
                    error={handleErrorMessage(
                      error,
                      'description',
                      this.state.errors.description
                    )}
                    multiline
                    rows={5}
                  />
                </div>
              </div>
              {!this.props.signal && (
                <div className="row">
                  <ButtonSave onClick={this.handleSubmit} />
                </div>
              )}
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddComplementRequestApproval,
  'ModalForAddComplementRequestApproval'
);
